module.exports = __webpack_public_path__ + "img/bg_main0102.0ec50a85.png";